import { ShieldAlert } from 'lucide-react';

import { supabase } from '../../lib/supabase';
import { StateButton, StateLink, StatePage } from './StatePage';

export function ForbiddenPage() {
  async function signOut() {
    await supabase.auth.signOut();
    window.location.assign('/auth/login');
  }

  return (
    <StatePage
      code="403"
      icon={ShieldAlert}
      tone="warning"
      title="אין לך הרשאה"
      body="הדף הזה דורש הרשאות שאין לחשבון שלך. פנה לבעלים של העסק כדי לשנות את התפקיד שלך."
      primary={<StateLink to="/">חזור לדף הבית</StateLink>}
      secondary={<StateButton onClick={() => { void signOut(); }}>התחבר עם חשבון אחר</StateButton>}
    />
  );
}
